module.exports = __webpack_public_path__ + "static/media/jawcore-2.bcfac570.jpg";